<template>
  <div class="order-item-warp">
    <div class="order-item-main">
      <div class="order-item-title">{{typeMap[item.pZujie]}}</div>
      <p><span>{{i18n.order_number}}</span>{{item.pOrderid}}</p>
      <p><span>{{i18n.time_rented}}</span>{{item.pBorrowtime | dateFmt}}</p>
      <p><span>{{i18n.venue_rented}}</span>{{item.pShopName}}</p>
    </div>
    <div class="order-item-foot" v-if="!isZujie">
      <div>
        <img src="../../assets/imgs/icon_time.png" alt="">
        <span class="value">{{item.pUseMins}} {{i18n.min}}</span>
      </div>
      <div>
        <!-- <img src="../../assets/imgs/icon_money.png" alt=""> -->
          <span class="currency_icon">{{ item.pCurrencyName }}</span>
        <span class="value">{{$money(item.pJiesuan)}} {{currency}}</span>
      </div>
      <span class="order-item-btn" v-if="item.palipayjsSm === '代扣支付失败' && item.pZujie !== 2" @click="onSubmit">
        {{i18n.payment}}
      </span>
    </div>
    <div class="order-item-foot" v-else>
      <div>
        <img src="../../assets/imgs/icon_time.png" alt="">
        <span class="value">{{parseInt(second/60)}} {{i18n.min}}</span>
      </div>
      <div>
        <!-- <img src="../../assets/imgs/icon_money.png" alt=""> -->
          <span class="currency_icon">{{ item.pCurrencyName }}</span>
        <span class="value">{{$money(amount)}} {{currency}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { ORDER_CHECK } from '@/apis/user'
import dayjs from 'dayjs'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['locale']),
    i18n () {
      return this.$t('order_item')
    },
    currency () {
      return this.item.pCurrency || this.locale.money
    },
    isZujie () {
      return this.item.pJiesuanid === 0 && (this.item.pZujie === 1 || this.item.pZujie === 4)
    }
  },
  data () {
    return {
      typeMap: {},
      amount: 0,
      second: 0,
      secondTimer: null
    }
  },
  methods: {
    onSubmit () {
      this.$router.push({ path: '/confirm', query: { price: this.item.pJiesuan, payType: 'FK', outTradeNo: this.item.pOrderid, cabinetID: this.item.pCabinetid } })
    },
    checkOrder () {
      this.$get(
        `${ORDER_CHECK}?orderId=${this.item.pOrderid}`,
        {},
        resp => {
          this.amount = resp.data.pJiesuan
          if (!(resp.data.pJiesuanid === 0 && (resp.data.pZujie === 1 || resp.data.pZujie === 4))) {
            this.delTimer()
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    checkTimer () {
      this.second = dayjs(new Date()).diff(this.$dateFmt(this.item.pBorrowtime), 'second')
      this.checkOrder()
      this.secondTimer = setInterval(() => {
        this.second++
        if (this.second % 60 === 1) {
          this.checkOrder()
        }
      }, 1000);
    },
    delTimer () {
      if (this.secondTimer) {
        clearInterval(this.secondTimer)
      }
    }
  },
  created () {
    this.typeMap = {
      0: this.i18n.type_0,
      1: this.i18n.type_1,
      2: this.i18n.type_2,
      3: this.i18n.type_3,
      4: this.i18n.type_4,
      5: this.i18n.type_5
    }
    if (this.isZujie) {
      this.checkTimer()
    }
  },
  beforeDestroy () {
    this.delTimer()
  }
}
</script>

<style lang="less">

.currency_icon {
  height: 40px;
  width: 40px;
  border: 1px solid #727070;
  border-radius: 50%;
  // padding: 5px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:22px ;

}
.order-item-warp + .order-item-warp {
  margin-top: 40px;
}
.order-item-warp {
  background-color: #fff;
  padding: 0 24px;
  border-radius: 20px;
  color: #727070;
  font-size: 24px;
  line-height: 40px;
  border: 1px solid #D5D5D5;
  .order-item-main {
    padding: 40px 24px 1px;
    span {
      padding-right: 24px;
    }
  }
  .order-item-title {
    font-size: 32px;
    color: #444444;
  }
  .order-item-foot {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-top: 2px dashed #707070;
    padding: 0 24px;
    div {
      height: 80px;
      width: 50%;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .value {
      font-weight: bold;
    }
    img {
      height: 40px;
      width: 40px;
      margin-right: 20px;
    }
    .order-item-btn {
      display: block;
      padding: 4px 20px;
      height: 0.6rem;
      background-color: #87d008;
      color: #fff;
      border-radius: 8px;
    }
  }
}
</style>
